import Utils from "./utils-service.js";
import Funnel from "./funnel-service.js";
import Vehicle from "./vehicle-service.js";
import Driver from "./driver-service.js";
import Disaster from "./disaster-service.js";
import Pet from "./pet-service.js";
import Home from "./home-service.js";
import Renters from "./renters-service.js";
import Recv from "./recv-service.js";
import RV from "./rv-service.js";
import RTQ from "./rtq-service.js";
import { throwError } from "../errors.js";

export default class FormInputs {
    // takes the Vuex context.
    constructor(lib) {
        this.ctx = lib.ctx;
        this.router = lib.router;
        this.servicesMap = {
            'Funnel': Funnel,
            'Vehicle': Vehicle,
            'Driver': Driver,
            'Disaster': Disaster,
            'Pet': Pet,
            'Home': Home,
            'Renters': Renters,
            'Recv': Recv,
            'RV': RV,
            'RTQ': RTQ
        };
    }

    eventHandler(e, input) {
        let fxn = null;
        if (Utils.isEmpty(input.vueService) && !Utils.isObjEmpty(input.fxn)) {
            fxn = input.fxn.component;
        } else if (!Utils.isObjEmpty(input.fxn) && !Utils.isEmpty(input.fxn[e.type])) {
            fxn = 'initService';
        }
        if (!Utils.isEmpty(fxn) && Object.keys(fxn).length != 0) {
            try {
                eval(`this.${fxn}(e, input)`);
            } catch (err) {
                let eMsg = `Error:- eventHandler: ${err}. calling non-existent function ${fxn}`
                console.error(eMsg, input);
                throwError(new Error(eMsg), { "fxn": fxn, "input": JSON.stringify(input) });
            }
        }
    }

    initService(e, input) {
        let service = input.vueService;
        let fxn = input.fxn[e.type];
        if (fxn === 'watch_action') {
            service = input.watch_action['vueService'];
            fxn = input.watch_action['fxn'];
        }

        const lib = {
            ctx: this.ctx,
            router: this.router
        }

        try {
            const srv = new this.servicesMap[service](lib);
            eval(`srv.${fxn}(e, input)`);
        } catch (err) {
            let eMsg = `Error:- initService: ${err}. calling non-existent function ${fxn} in ${service}`
            console.log(eMsg);
            throwError(new Error(eMsg), { "lib": lib, "service": service, "fxn": fxn, "input": JSON.stringify(input) });
        }
    }

    startVehiclePrefill(e, input) {
        //e.preventDefault();
        console.log('Event obj is:', e);
        console.log('FormInput ...', input);
        //this.ctx.dispatch('processVehiclePrefill');
    }

    updatedValueCheckbox(e, input) {
        console.log(input);
        const fieldId = e.currentTarget.id
        const updatedValue = e.target.value
        console.log(updatedValue);
        this.ctx.dispatch('updateField', { fieldId, updatedValue })
    }

}